import { useEffect, useRef } from 'react';
import type { FC } from 'react';

import * as styles from './Card.module.scss';

export interface CardProps {
  imageUrl: string;
  name: string;
  index?: number;
  onIntersectionChange?: (
    entry: IntersectionObserverEntry,
    index: number
  ) => void;
}

export const Card: FC<CardProps> = ({
  onIntersectionChange,
  imageUrl,
  name,
  index,
}) => {
  const ref = useRef<HTMLDivElement>(null!);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        onIntersectionChange?.(entry, index!);
      },
      { threshold: [0, 0.85] }
    );

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [onIntersectionChange, index]);

  return (
    <div className={styles.card} ref={ref}>
      <img src={`${imageUrl}?t[]=1080x1920q80`} alt={name} />
    </div>
  );
};
